<div class="container" [ngClass]="generalClass" *ngIf="!valueIsNull">
        <div class="texte">{{'ACTIVESLOTS.PHASE.VERIFICATIONCODE' | translate}}</div>
        <div class="texte-curt">{{'ACTIVESLOTS.PHASE.VERIFICATIONCODECURT' | translate}}</div>
        <div class="verificationCode">{{value.secret}}<shared-copyclipboard class="strong clipboard"
                        [value]="value.secret"></shared-copyclipboard>
        </div>
</div>